import {
  FULL_PARTNER,
  sessionIDRegex,
  instructionList,
  instructionData,
  instructionDataPlateLeft,
  instructionDataPlateRight,
  instructionDataRearTire,
  instructionDataLite,
  instructionDataForHolmanClient,
  themeActions,
} from './config';
import { map } from 'lodash';

export const isPartner = (string) => {
  let partnerName = '';
  const getPrefix = string.substring(0, 3);
  if (
    getPrefix === 'SCI' ||
    getPrefix === 'USL' ||
    getPrefix === 'TSL' ||
    getPrefix === 'TSC'
  ) {
    partnerName = FULL_PARTNER.SCI_PARTNER;
  }
  if (getPrefix === 'UAD' || getPrefix === 'CDE' || getPrefix === 'TDT') {
    partnerName = FULL_PARTNER.DEALER_PARTNER;
  }
  if (
    getPrefix === 'CDD' ||
    getPrefix === 'UAC' ||
    getPrefix === 'TDD' ||
    getPrefix === 'TDC' ||
    getPrefix === 'TDA'
  ) {
    partnerName = FULL_PARTNER.DEALER_TRACK_PARTNER;
  }
  if (
    getPrefix === 'CMA' ||
    getPrefix === 'UAT' ||
    getPrefix === 'TMV' ||
    getPrefix === 'MMA' ||
    getPrefix === 'TMM'
  ) {
    partnerName = FULL_PARTNER.MUVIT_PARTNER;
  }
  if (getPrefix === 'DDE' || getPrefix === 'TCU' || getPrefix === 'IUS') {
    partnerName = FULL_PARTNER.COX_USA_PARTNER;
  }
  if (
    getPrefix === 'TPI' ||
    getPrefix === 'PIM' ||
    getPrefix === 'DSI' ||
    getPrefix === 'UPI' ||
    getPrefix === 'TIM'
  ) {
    partnerName = FULL_PARTNER.NONE_REPORT_PARTNER;
  }
  return partnerName;
};

export const getIDPartner = (id) => {
  let name = '';
  if (id.match(sessionIDRegex)) {
    const getSessionID = id.match(sessionIDRegex)[0];
    name = isPartner(getSessionID);
  }
  return name;
};

export const getDataMockupProcess = (type, flow = [], screen = []) => {
  if (screen.length > 0) {
    return map(screen, (code, pos) => {
      return { ...instructionList[code], key: pos + 1 };
    });
  }

  switch (type) {
    case themeActions.PAVE_PLATE_LEFT:
      return instructionDataPlateLeft;
    case themeActions.PAVE_PLATE_RIGHT:
      return instructionDataPlateRight;
    case themeActions.PAVE_REAR_TIRE:
      return instructionDataRearTire;
    case 'LITE':
      return instructionDataLite;
    case 'HOLMAN':
      return instructionDataForHolmanClient;
    case 'CAPT':
    case 'CUSTOM':
      return map(flow, (code, pos) => {
        return { ...instructionList[code], key: pos + 1 };
      });
    default:
      return instructionData;
  }
};
